<template>
  <TheSidebarMenuLayout>
    <AppTooltip
      v-for="link in links"
      :key="link.label"
      :placement="linkMessagePosition"
      :message="link.title"
      :active="link.disabled || !link.to"
    >
      <template #tooltip-handler>
        <AppLinkIcon :link-item="link" :show-label="!isMobile" :class="borderTopClass(link)" />
      </template>
    </AppTooltip>
  </TheSidebarMenuLayout>
</template>

<script>
// Utilities
import { loadCurretUser } from '@/services/helpers'
import SidebarMenu from '../mixins/SidebarMenu'
// Components
import AppTooltip from 'Ui/AppTooltip'

export default {
  name: 'TheSidebarMenuClient',

  components: {
    AppTooltip,
  },

  mixins: [SidebarMenu],

  computed: {
    currentClientAccount() {
      return this.$store.state.client.account || {}
    },

    isTurboMode() {
      return this.currentClientAccount.pack_name == 'modo turbo'
    },

    links() {
      return [
        {
          label: 'Dashboard',
          to: { name: 'dashboard-client', params: { account_id: loadCurretUser().account.id } },
          icon: 'far fa-th',
        },
        // ROADMAP
        {
          label: this.$t('sidebar.menu.labels.roadmap'),
          to: this.currentClientAccount.roadmap,
          icon: 'far fa-map-marked',
          class: 'border-top',
          external: true,
          title: !this.currentClientAccount.roadmap
            ? this.$t('ui.tooltips.sidebar.service_not_available')
            : '',
        },
        // ATIM REPORT
        {
          label: this.$t('sidebar.menu.labels.atim_report'),
          to: this.currentClientAccount.atim,
          icon: 'far fa-user-chart',
          border: true,
          external: true,
          title: !this.currentClientAccount.atim
            ? this.$t('ui.tooltips.sidebar.service_not_available')
            : '',
        },
        // CONSULTING CALL
        {
          label: this.$t('sidebar.menu.labels.call'),
          to: this.isTurboMode ? this.currentClientAccount.consulting_call : '',
          icon:
            !this.isTurboMode || !this.currentClientAccount.consulting_call
              ? 'far fa-phone-slash'
              : 'far fa-phone',
          disabled: !this.isTurboMode || !this.currentClientAccount.consulting_call,
          external: true,
          title: this.consultingCallMessage,
        },
      ]
    },

    consultingCallMessage() {
      let message = ''
      if (!this.isTurboMode) message = this.$t('ui.tooltips.sidebar.consulting_call_unavailable')

      if (!this.currentClientAccount.consulting_call && this.isTurboMode)
        message = this.$t('ui.tooltips.sidebar.consulting_call_pending')

      return message
    },

    linkMessagePosition() {
      return this.isMobile ? 'top' : 'right'
    },
  },
}
</script>

<style scoped>
.diy-sidebar__menu .diy-tooltip {
  overflow: hidden;
}
</style>
